import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27189f80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_5 = { class: "card-body p-25" }
const _hoisted_6 = { class: "row mb-4" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Période", -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<option value=\"all\" data-v-27189f80>Toute la période</option><option value=\"today\" data-v-27189f80>Aujourd&#39;hui</option><option value=\"week\" data-v-27189f80>Cette semaine</option><option value=\"month\" data-v-27189f80>Ce mois</option><option value=\"year\" data-v-27189f80>Cette année</option>", 5)
const _hoisted_14 = [
  _hoisted_9
]
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Date de début", -1))
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Date de fin", -1))
const _hoisted_19 = { class: "row mb-4" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "card border-0 bg-light" }
const _hoisted_22 = { class: "card-body text-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye fs-30 text-primary mb-2" }, null, -1))
const _hoisted_24 = { class: "fw-bold mb-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Total lectures", -1))
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = { class: "card border-0 bg-light" }
const _hoisted_28 = { class: "card-body text-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book fs-30 text-success mb-2" }, null, -1))
const _hoisted_30 = { class: "fw-bold mb-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Documents uniques", -1))
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "card border-0 bg-light" }
const _hoisted_34 = { class: "card-body text-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar fs-30 text-warning mb-2" }, null, -1))
const _hoisted_36 = { class: "fw-bold mb-1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Aujourd'hui", -1))
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = { class: "card border-0 bg-light" }
const _hoisted_40 = { class: "card-body text-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-time fs-30 text-info mb-2" }, null, -1))
const _hoisted_42 = { class: "fw-bold mb-1" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Cette semaine", -1))
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table table-hover" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Document"),
    /*#__PURE__*/_createElementVNode("th", null, "Catégorie"),
    /*#__PURE__*/_createElementVNode("th", null, "Date de lecture"),
    /*#__PURE__*/_createElementVNode("th", null, "Heure"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_47 = { class: "d-flex align-items-center" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 me-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "bg-primary rounded-circle p-2",
    style: {"width":"40px","height":"40px"}
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book text-white fs-16" })
  ])
], -1))
const _hoisted_49 = { class: "mb-0 fw-semibold" }
const _hoisted_50 = { class: "text-muted" }
const _hoisted_51 = { class: "badge bg-secondary" }
const _hoisted_52 = { class: "d-flex gap-2" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye" }, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download" }, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_60 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book fs-1 text-muted" }, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-muted mt-3" }, "Aucun historique trouvé", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Votre historique de lecture apparaîtra ici.", -1))
const _hoisted_64 = [
  _hoisted_61,
  _hoisted_62,
  _hoisted_63
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                }, _hoisted_14, 544), [
                  [_vModelSelect, _ctx.selectedPeriod]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.startDate]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.endDate]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("h5", _hoisted_24, _toDisplayString(_ctx.totalLectures), 1),
                    _hoisted_25
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.documentsUniques), 1),
                    _hoisted_31
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("h5", _hoisted_36, _toDisplayString(_ctx.lecturesAujourdhui), 1),
                    _hoisted_37
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("h5", _hoisted_42, _toDisplayString(_ctx.lecturesCetteSemaine), 1),
                    _hoisted_43
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("table", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historiques, (historique) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: historique.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("div", null, [
                            _createElementVNode("h6", _hoisted_49, _toDisplayString(historique.document?.titre || 'Titre non disponible'), 1),
                            _createElementVNode("small", _hoisted_50, " Par " + _toDisplayString(historique.document?.auteur.nom || 'Auteur inconnu') + " " + _toDisplayString(historique.document?.auteur.prenoms || 'Auteur inconnu'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_51, _toDisplayString(historique.document?.categorie?.nom || 'Non définie'), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(historique.createdAt)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(historique.createdAt)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-outline-primary",
                            onClick: ($event: any) => (_ctx.voirDocument(historique.document)),
                            title: "Voir le document"
                          }, _hoisted_55, 8, _hoisted_53),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-outline-success",
                            onClick: ($event: any) => (_ctx.telechargerDocument(historique.document)),
                            title: "Télécharger"
                          }, _hoisted_58, 8, _hoisted_56)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_PaginationComponent, {
                  page: _ctx.page,
                  totalPages: _ctx.totalPages,
                  totalElements: _ctx.totalElements,
                  limit: _ctx.limit,
                  onPaginate: _ctx.handlePaginate
                }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
              ]),
              (_ctx.historiques.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}